import api from "../api";
import uuid from "uuid";
import moment from "moment";
import {
  PROJECT_CREATE_SUCCESS,
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_FAILURE,
  PROJECT_LIST_REQUEST,
  PROJECT_LIST_SUCCESS,
  PROJECT_LIST_FAILURE,
  PROJECT_DELETE_REQUEST,
  PROJECT_DELETE_SUCCESS,
  PROJECT_DELETE_FAILURE,
  PROJECT_UPLOAD_DATASET_PROGRESS,
  PROJECT_UPDATE_DURATION,
} from "./types";
import { timeToStale } from "../constants";
import { notificationDisplay } from "./notificationActions";

const DEFAULT_ERROR = "Projects endpoint error";

// ---------------- CREATE PROJECT ----------------
const projectCreateRequest = (project, tmpId) => ({
  type: PROJECT_CREATE_REQUEST,
  project,
  tmpId,
});
const projectUploadDatasetProgress = (tmpId, progress) => ({
  type: PROJECT_UPLOAD_DATASET_PROGRESS,
  tmpId,
  progress,
});

const projectCreateSuccess = (project, tmpId) => ({
  type: PROJECT_CREATE_SUCCESS,
  project,
  tmpId,
});

const projectCreateFailure = (error, tmpId) => ({
  type: PROJECT_CREATE_FAILURE,
  error,
  tmpId,
});

export const projectCreate = (project) => async (dispatch) => {
  const tmpId = uuid.v4();
  dispatch(projectCreateRequest(project, tmpId));
  const successHandler = (resp, tmpId) => {
    const newProject = JSON.parse(resp);
    dispatch(projectCreateSuccess(newProject, tmpId));
  };
  const errorHandler = (resp, status, tmpId) => {
    let detail;
    switch (status) {
      case 422:
        detail = JSON.parse(resp).detail;
        dispatch(projectCreateFailure(DEFAULT_ERROR, tmpId));
        dispatch(
          notificationDisplay(
            "error",
            detail.map((d) => `${d.loc[d.loc.length - 1]}: ${d.msg}`)
          )
        );
        break;
      default:
        console.log(PROJECT_CREATE_FAILURE, status);
        dispatch(projectCreateFailure(DEFAULT_ERROR, tmpId));
        dispatch(notificationDisplay("error", [DEFAULT_ERROR]));
        break;
    }
  };
  const uploadProgressHandler = (e) => {
    if (e.lengthComputable) {
      const progress = (e.loaded / e.total) * 100;
      dispatch(projectUploadDatasetProgress(tmpId, progress));
    }
  };
  api.recorder.project.create(
    project,
    tmpId,
    successHandler,
    errorHandler,
    uploadProgressHandler
  );
};

// ---------------- LIST PROJECTS ----------------
const projectListRequest = () => ({
  type: PROJECT_LIST_REQUEST,
});

const projectListSuccess = (projects) => ({
  type: PROJECT_LIST_SUCCESS,
  projects,
});

const projectListFailure = (error) => ({
  type: PROJECT_LIST_FAILURE,
  error,
});

export const projectList = () => async (dispatch, getState) => {
  // check cache
  const cachedAt = getState().projects.cachedAt;
  if (moment().diff(cachedAt, "m") < timeToStale) return;
  // cache got stale
  dispatch(projectListRequest());
  let resp, status, detail;
  try {
    resp = await api.recorder.project.list();
    status = resp.status;
  } catch (error) {
    console.log(PROJECT_LIST_FAILURE, error);
    dispatch(projectListFailure(DEFAULT_ERROR));
  }
  switch (status) {
    case 200: {
      const projects = await resp.json();
      dispatch(projectListSuccess(projects));
      break;
    }
    case 403:
      detail = resp.json().detail;
      dispatch(projectListFailure(detail));
      dispatch(notificationDisplay("error", [detail]));
      break;
    default:
      console.log(PROJECT_LIST_FAILURE, status);
      dispatch(projectListFailure(DEFAULT_ERROR));
      dispatch(notificationDisplay("error", [DEFAULT_ERROR]));
      break;
  }
};

// ---------------- DELETE PROJECT ----------------
const projectDeleteRequest = (projectId) => ({
  type: PROJECT_DELETE_REQUEST,
  projectId,
});

const projectDeleteSuccess = (project) => ({
  type: PROJECT_DELETE_SUCCESS,
  project,
});

const projectDeleteFailure = (projectId) => ({
  type: PROJECT_DELETE_FAILURE,
  projectId,
});

export const projectDelete = (projectId) => async (dispatch) => {
  dispatch(projectDeleteRequest(projectId));
  let resp, status, detail;
  try {
    resp = await api.recorder.project.delete(projectId);
    status = resp.status;
  } catch (error) {
    console.log(PROJECT_DELETE_FAILURE, error);
    dispatch(projectDeleteFailure, DEFAULT_ERROR);
  }
  switch (status) {
    case 200: {
      const deletedProject = await resp.json();
      dispatch(projectDeleteSuccess(deletedProject));
      break;
    }
    case 403:
      detail = resp.json().detail;
      dispatch(projectDeleteFailure(detail));
      dispatch(notificationDisplay("error", [detail]));
      break;
    case 422:
      detail = await resp.json().detail;
      dispatch(
        notificationDisplay(
          "error",
          detail.map((d) => `${d.loc[d.loc.length - 1]}: ${d.msg}`)
        )
      );
      break;
    default:
      console.log(PROJECT_DELETE_FAILURE, status);
      dispatch(projectDeleteFailure(DEFAULT_ERROR));
      dispatch(notificationDisplay("error", [DEFAULT_ERROR]));
      break;
  }
};

// ---------------- UPDATE RECORDED DURATION ----------------
export const projectUpdateRecordedDuration = (projectId, duration) => ({
  type: PROJECT_UPDATE_DURATION,
  projectId,
  duration,
});
